import { Switch } from '@mui/material'
import { toast } from 'react-toastify'

import { useChangeAppFeatureStatusMutation } from 'generated/graphql'
import { GET_WEC_AI_SCHEDULERS_APP_FEATURES } from 'graphql/queries/AppFeatureQueries'
import { usePermission } from 'providers'

interface IWecAiSchedulerStateSwitchProps {
  name: string
  state: boolean
}

const WecAiSchedulerStateSwitch = ({ name, state }: IWecAiSchedulerStateSwitchProps) => {
  const [isAllowedToChangeAppFeature] = usePermission('UpdateAppFeature')

  const [changeAppFeatureStatus, { loading }] = useChangeAppFeatureStatusMutation({
    refetchQueries: [{ query: GET_WEC_AI_SCHEDULERS_APP_FEATURES }],
    awaitRefetchQueries: true,
  })

  const handleChange = async () => {
    if (!isAllowedToChangeAppFeature) return

    try {
      await changeAppFeatureStatus({ variables: { name } })
    } catch (e) {
      toast.error('Something went wrong while changing the feature status')
      console.error(e)
    }
  }

  return (
    <Switch
      checked={state}
      onChange={handleChange}
      disabled={!isAllowedToChangeAppFeature || loading}
    />
  )
}

export default WecAiSchedulerStateSwitch
